import { Entity } from '@core/data/dto/entity';
import { Address } from '@core/models/common/address';
import { DeliveryOrderDropoffVerification } from './delivery-order-dropoff-verification';
import { DtoImport, DtoExport } from '@core/utils/dto';
import { DTO_DEFAULT, DtoType } from '@core/data/dto/dto-types';
import { Dto } from '@core/data/dto/dto';
import { DeliveryOrderLocation } from '../delivery-order-location';
import { DeliveryOrderDropoffSchema } from './delivery-order-dropoff.schema';

export class DeliveryOrderDropoff implements Entity {
    public name: string;
    public phoneNumber: string;
    public address: string;
    public notes: string;
    public location: DeliveryOrderLocation;
    public detailedAddress: Address;
    public verification: DeliveryOrderDropoffVerification;

    @DtoImport(DeliveryOrderDropoffSchema)
    static import(dto: Dto): any {}

    @DtoExport([
        {
            type: DTO_DEFAULT,
            dto: DeliveryOrderDropoffSchema,
        },
    ])
    export(type?: DtoType): any {}
}
